import { MobileDevicePreview, Prose } from '@payaca/ambrosia';
import ShadowDomRenderer from '@payaca/components/shadowDomRenderer/ShadowDomRenderer';
import { clstx } from '@payaca/utilities/cvaMerge';
import { FC } from 'react';

/**
 * Renders a document template preview: in a phone frame when `isMobile`,
 * otherwise as a full-width panel.
 */
const DocumentTemplatePreview: FC<{ html: string; isMobile?: boolean }> = (
  props
) => {
  const { html, isMobile } = props;

  return (
    <MobileDevicePreview
      className={clstx(
        'mx-auto bg-white',
        // oxlint-disable-next-line payaca/no-tailwind-arbitrary-values -- Limits the transition to these properties
        'transition-[width] duration-300 ease-in-out',
        !isMobile && 'w-full rounded-sm border-1 border-gray-200 h-max'
      )}
    >
      <Prose>
        <ShadowDomRenderer html={html} />
      </Prose>
    </MobileDevicePreview>
  );
};

export default DocumentTemplatePreview;
